<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span class="bind">修改密码</span>
          </div>
          <el-form
            :model="adminForm"
            :rules="rules"
            ref="adminForm"
            label-width="150px"
            class="adminForm">
            <el-form-item
              :label="$t('旧密码')"
              prop="password">
              <el-input
                type="password"
                v-model="adminForm.password"/>
            </el-form-item>
            <el-form-item
              :label="$t('新密码')"
              prop="passwordnew1">
              <el-input
                type="password"
                v-model="adminForm.passwordnew1"/>
            </el-form-item>
            <el-form-item
              :label="$t('确认密码')"
              prop="passwordnew2">
              <el-input
                type="password"
                v-model="adminForm.passwordnew2"/>
            </el-form-item>
            <el-form-item>
              <el-button
                type="success"
                @click="sendForm">{{ btnSubTxt }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .adminForm .el-input {
    width: 16%;
    min-width: 200px;
    margin-right: .75em;
  }
</style>
<script>
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';

export default {
  components: { jmToolbar, jmTableList },
  data() {
    return {
      refresh: false,
      disabled: false,
      btnSubTxt: this.$t('确认修改'),
      // test data
      adminId: null,
      adminForm: {
        password: '',
        passwordnew1: '',
        passwordnew2: '',
      },
      rules: {
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        passwordnew1: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        passwordnew2: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    fetchMenu () {
      this.refresh = true;
    },
    sendForm() {
      let ruleData = Object.assign({}, this.adminForm);
      let flag = false;
      this.$refs.adminForm.validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          window.scrollTo(0, 0);
          return false;
        }
      });
      if (!flag) {
        return false;
      }
      this.$http._post({
        url: '/index/system/checkPwd',
        data: ruleData
      })
        .then((res) => {
          this.$message({ message: res.msg, type: res.result !== 0 ? 'error' : 'success' });
          if (res.result > -1) {
            if (res.data === '/login') {
              window.location.href = res.data;
            } else {
              this.$router.push({ name: res.data });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {},
  mounted() {}
};
</script>
